export const CLEAR_APP_STATE = 'CLEAR_APP_STATE';
export const MEDIA_CHANGE = 'MEDIA_CHANGE';
export const ADD_CASE = 'ADD_CASE';
export const EDIT_CASE = 'EDIT_CASE';
export const DELETE_CASE = 'DELETE_CASE';
